import { cn } from '~/shared/lib/utils'

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-foreground/8', className)} {...props} />
}

export { Skeleton }
